import React, { useState } from "react";
import { StyleSheet } from "react-native";

// import '../../index.css'

interface Props {
  text?: string;
  children?: React.ReactNode;
  fontSize?: string;
  width?: string;
  backgroundColor?: string;
  color?: string;
  border?: string;
  transform?: string;
}

export const Tooltip = ({
  text,
  children,
  fontSize,
  width,
  backgroundColor,
  color,
  border,
  transform,
}: Props) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  return (
    <div
      style={styles.tooltipContainer}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {isVisible && (
        <div
          style={{
            ...styles.tooltip,
            fontSize: fontSize ?? "0.75rem",
            width: width ?? "120px",
            backgroundColor: backgroundColor ?? "#000",
            color: color ?? "#fff",
            border: border ?? "none",
            transform: transform ?? "translateX(-50%)",
            zIndex: 9999,
          }}
        >
          {text}
        </div>
      )}
      <div style={{ zIndex: 1 }}>{children}</div>
    </div>
  );
};

const styles = StyleSheet.create<any>({
  tooltipContainer: {
    position: "relative",
    display: "inline-block",
    zIndex: 1,
    isolation: "isolate",
  },
  tooltip: {
    position: "absolute",
    textAlign: "center",
    top: "100%",
    left: "50%",
    padding: "0.5rem",
    borderRadius: "0.5rem",
    transform: "translateX(-50%)",
    backgroundColor: "#000",
    color: "#fff",
    zIndex: 9999,
    "&::after": {
      content: '""',
      position: "absolute",
      top: "0",
      left: "50%",
      transform: "translateX(-50%)",
      width: "0",
      height: "0",
      borderLeft: "0.5rem solid transparent",
      borderRight: "0.5rem solid transparent",
      borderBottom: "0.5rem solid #000",
      zIndex: 9999,
    },
  },
});

export default Tooltip;
